<div>
	<!--Top Table, Applications/Modules-->
	<div>
		<caass-application-table (ApplicationSelected)="onApplicationSelected($event)"> </caass-application-table>
	</div>

	<!--Bottom Table, Schools-->
	<div class="AccordianDiv">
		<p-accordion>
			<p-accordionTab header="Schools {{ SchoolExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}" [(selected)]="SchoolExpand">
				<div>
					<caass-school-table (TableChange)="onTableChange()" [ApplicationID]="ApplicationID"> </caass-school-table>
				</div>
			</p-accordionTab>
		</p-accordion>
	</div>

	<!--Pages-->
	<div class="AccordianDiv">
		<p-accordion>
			<p-accordionTab header="Menu Items {{ MenuItemExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}" [(selected)]="MenuItemExpand">
				<div>
					<caass-application-item-table [ApplicationID]="ApplicationID"> </caass-application-item-table>
				</div>
			</p-accordionTab>
		</p-accordion>
	</div>
</div>
